// Google Maps configuration constants
export const GOOGLE_MAPS_LIBRARIES: 'places'[] = ['places'] as const

export const GOOGLE_MAPS_OPTIONS = {
  language: 'he',
  region: 'IL',
} as const
